<kendo-dialog [title]="referenceDataLabels.CreditSearch | localizeLabel" (close)="close()" [width]="640">
  <div class="warning-container bo-info-text notification-error">
    <div class="notification-error-icon"></div>
    <h1 class="vo-heading-bold-18 mb-15" [innerHTML]="warningLabel | localizeLabel">
    </h1>

    <div class="pre white-space-pre-line" [innerHTML]="warningContentLabel | localizeLabel"></div>
  </div>

  <kendo-dialog-actions class="modal-buttons">
    <div class="left-column mb-md-0 mb-15">
      <a (click)="close()" [innerHtml]="referenceDataLabels.CancelId|localizeLabel" class="link vo-secondary-button-1"></a>
    </div>
    <div class="right-column">
      <button (click)="confirm()" [innerHtml]="referenceDataLabels.FinaliseSubmission | localizeLabel"
        class="primary-button vo-primary-button-1"></button>
    </div>
  </kendo-dialog-actions>
</kendo-dialog>